module.exports = __webpack_public_path__ + "static/img/stock-photo-thoughtful-young-mixed-race-businessman-in-glasses-holding-paper-document-reading-banking-debt-1660489855.3ef5f2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stock-photo-thoughtful-young-mixed-race-businessman-in-glasses-holding-paper-document-reading-banking-debt-1660489855.jpg
// module id = fv8G
// module chunks = 1